<template>
  <layout-content>
    <div class="row">
      <div class="col-12">
        <widgets-list
          v-if="auth_data.status === 'connected' || auth_data.status === 'disconnected'"
          :auth_data="auth_data"
        />
        <div v-if="!auth_data.status" class="flex flex--center flex--row-center">
          <spin size="large" />
          <span> {{ $t('integrations.page.button.loading') }} </span>
        </div>
      </div>
    </div>
  </layout-content>
</template>

<script>
  import { AmoService } from '@amo-widget/services/AmoService';
  import WidgetsList from './widgets-list';

  export default {
    components: {
      WidgetsList
    },
    data: () => ({
      auth_data: {
        status: '',
        amo_login: null,
        base_domain: null,
        trunks_ready: false,
        number: '',
        auth_url: '',
        auth: {
          'amocrm.ru': '',
          'kommo.com': ''
        }
      }
    }),
    watch: {
      '$i18n.locale': function (locale) {
        if (locale === 'id') {
          this.need_show = false;
        } else {
          this.need_show = true;
        }
      }
    },
    async mounted() {
      this.auth_data = await AmoService.isAuth();
    },
    created() {
      const { locale } = this.$user;

      if (locale === 'id') {
        this.need_show = false;
      } else {
        this.need_show = true;
      }
    }
  };
</script>
<style lang="scss">
  $amo: #529bc3;
  $kommo: #0006a1;

  .logo-crm {
    width: 240px;
    height: 84px;
    padding: 20px 10px;

    &--amo {
      background-color: $amo;
    }
    &--kommo {
      background-color: $kommo;
    }
  }

</style>
